import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import DateIcon from '../../icons/DateIcon';
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from "../../icons/CloseIcon";
import translate from '../../other/translate.json'
import axios from 'axios'
import config from '../../other/config';
const { serverAPI } = config;


export default function VersionPlanDrawer(props) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	// const [dynamicsDesc, setDynamicsDesc] = useState('');
	// const [dynamicsVersions, setDynamicsVersions] = useState([]);
	let lang = localStorage.getItem('language') || 'Ru'

	// useEffect(() => {
	// 	let didCancel = false;
	// 	async function fetchData() {
	// 		const dataDynamicsSection = await axios.get(`${serverAPI}/dynamics_info/${lang}`)
	// 		if (!didCancel) {
	// 			setDynamicsDesc(dataDynamicsSection.data[0][`VersionInfo`])
	// 			setDynamicsVersions(JSON.parse(dataDynamicsSection.data[0].Versions))
	// 		}
	// 	}
	// 	fetchData();
	// 	return () => {
	// 		didCancel = true;
	// 	};
	// }, []);


	const toggleDrawer = (open) => (event) => {
		if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
			return;
		}

		setOpen(open);
	};

	const list = (anchor) => (
		<Grid
			className={classes.list}
			role="presentation"
			// onClick={toggleDrawer(false)} 
			onKeyDown={toggleDrawer(false)}
		>
			<Grid item container direction="row" style={{ marginTop: 48 }}>
				<Typography className={[classes.version, classes.Body1]}>{translate.Words[`Version${lang}`]}</Typography>
				<Typography className={[classes.date, classes.Body1]}>{translate.Words[`PlannedReleaseDate${lang}`]}</Typography>
				{JSON.stringify(props.dynamicsVersions).includes("actualDateVers") ? <Typography className={[classes.date, classes.Body1]}>{translate.Words[`ActualReleaseDate${lang}`]}</Typography> : null}
			</Grid>

			<Grid item container style={{ marginTop: 19 }}>
				{props.dynamicsVersions.map(el =>
					el.publishVers > 0
						?
						<Grid item container direction="row" style={{ marginTop: 8, marginBottom: 8 }}>
							<Typography className={[classes.Title4, classes.version]}>{el.vers}</Typography>
							<Typography className={[classes.Title4, classes.date]}>{el.dateVers}</Typography>
							{JSON.stringify(props.dynamicsVersions).includes("actualDateVers") ? <Typography className={[classes.Title4, classes.date]}>{el.actualDateVers}</Typography> : null}
						</Grid>
						:
						null
				)}
			</Grid>

			<Grid item style={{ marginTop: 32 }}>
				<Typography className={classes.Body1}>
					<div dangerouslySetInnerHTML={{ __html: props.dynamicsDesc }}></div>
				</Typography>
			</Grid>
		</Grid>
	);

	return (
		<React.Fragment>
			<Button
				// variant="contained"
				// color="primary"
				size="small"
				className={classes.button}
				startIcon={<DateIcon fill={'#BCBBD0'} />}
				onClick={toggleDrawer(true)}
			>
				{translate.Words[`ReleasePlan${lang}`]}
			</Button>

			<Drawer anchor={'right'} open={open} onClose={toggleDrawer(false)}>
				<Grid container>
					<Grid className={classes.btnClose}>
						<IconButton onClick={toggleDrawer(false)} aria-label="filter" className={classes.btnFilter}>
							<CloseIcon fill='#BCBBD0' />
						</IconButton>
					</Grid>

					<Grid item style={{ marginTop: 30 }}>
						<Typography className={classes.listHeader} style={{ paddingLeft: 56, paddingRight: 56 }}>
							{translate.Words[`ReleasePlan${lang}`]}
						</Typography>
					</Grid>
				</Grid>
				{list('right')}
			</Drawer>
		</React.Fragment>
	);
}

const useStyles = makeStyles({
	list: {
		maxWidth: 600,
		paddingLeft: 56,
		paddingRight: 56
	},

	smallList: {
		width: 'auto',
	},

	listHeader: {
		fontWeight: 500,
		fontSize: '24px',
		lineHeight: '32px',
		color: '#24262A'
	},

	btnClose: {
		position: 'absolute',
		right: 12,
		top: 12,
	},

	Body1: {
		fontFamily: "Cera CY",
		fontStyle: "normal",
		fontWeight: "normal",
		fontSize: "16px",
		lineHeight: "24px",
		color: "#8987A2",
	},

	Title4: {
		fontFamily: "Cera CY",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "18px",
		lineHeight: "28px",
		color: "#24262A",
	},

	button: {
		textTransform: 'unset',
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '16px',
		lineHeight: '24px',
		color: '#24262A',
		marginTop: 17,
		padding: "4px 2px"
	},

	version: {
		width: 73
	},

	date: {
		width: 112,
		padding: '0 4px'
	}
});